export var SignalType;
(function (SignalType) {
    SignalType[SignalType["Topics"] = 1] = "Topics";
    SignalType[SignalType["Keywords"] = 2] = "Keywords";
    SignalType[SignalType["HVC"] = 3] = "HVC";
    SignalType[SignalType["Social"] = 4] = "Social";
    SignalType[SignalType["TechTarget"] = 6] = "TechTarget";
    SignalType[SignalType["Aberdeen"] = 7] = "Aberdeen";
    SignalType[SignalType["SiteVisitor"] = 8] = "SiteVisitor";
    SignalType[SignalType["Display"] = 9] = "Display";
    SignalType[SignalType["Leads"] = 10] = "Leads";
    SignalType[SignalType["Demandbase"] = 11] = "Demandbase";
    SignalType[SignalType["SixthSense"] = 12] = "SixthSense";
    SignalType[SignalType["G2Crowd"] = 13] = "G2Crowd";
    SignalType[SignalType["Dynamic1"] = 14] = "Dynamic1";
    SignalType[SignalType["Stage"] = 17] = "Stage";
    SignalType[SignalType["BusinessEvent"] = 18] = "BusinessEvent";
    SignalType[SignalType["MarketoEngagement"] = 22] = "MarketoEngagement";
    SignalType[SignalType["SalesforceActivity"] = 23] = "SalesforceActivity";
})(SignalType || (SignalType = {}));
export const signalLabels = {
    [SignalType.Topics]: 'Topics',
    [SignalType.Keywords]: 'Keywords',
    [SignalType.HVC]: 'HVCs',
    [SignalType.Social]: 'Social',
    [SignalType.TechTarget]: 'Tech Targets',
    [SignalType.Aberdeen]: 'Aberdeen',
    [SignalType.SiteVisitor]: 'Site Visitors',
    [SignalType.Display]: 'Digital',
    [SignalType.Leads]: 'Leads',
    [SignalType.Demandbase]: 'Demandbase',
    [SignalType.SixthSense]: '6Sense',
    [SignalType.G2Crowd]: 'G2Crowd',
    [SignalType.Dynamic1]: 'Dynamic1',
    [SignalType.Stage]: 'Stage',
    [SignalType.BusinessEvent]: 'Business Events',
    [SignalType.MarketoEngagement]: 'Marketo Engagement',
    [SignalType.SalesforceActivity]: 'Salesforce Activity',
};
export const signalLabelsSingular = {
    [SignalType.Topics]: 'Topic',
    [SignalType.Keywords]: 'Keyword',
    [SignalType.HVC]: 'HVC',
    [SignalType.Social]: 'Social',
    [SignalType.TechTarget]: 'Tech Target',
    [SignalType.Aberdeen]: 'Aberdeen',
    [SignalType.SiteVisitor]: 'Site Visitor',
    [SignalType.Display]: 'Digital',
    [SignalType.Leads]: 'Lead',
    [SignalType.Demandbase]: 'Demandbase',
    [SignalType.SixthSense]: '6Sense',
    [SignalType.G2Crowd]: 'G2Crowd',
    [SignalType.Dynamic1]: 'Dynamic1',
    [SignalType.Stage]: 'Stage',
    [SignalType.BusinessEvent]: 'Business Event',
    [SignalType.MarketoEngagement]: 'Marketo Engagement',
    [SignalType.SalesforceActivity]: 'Salesforce Activity',
};
//# sourceMappingURL=Signal.js.map